/* eslint-disable max-len */

export const BESTDEALS_FAQ_DATA = [
  {
    open: false,
    question: 'Where Can I Find the Best Deals on Electronics?',
    answer: `
              <p class="c8">You’ve come to the right place—welcome to Popsy! As a leading global marketplace for refurbished tech, Popsy is your go-to destination for incredible deals on electronics. With savings of 30-70% compared to the price of buying new, you can upgrade your gadgets without breaking the bank.
</p>
     <p class="c8"> At Popsy, we’re committed to quality. Every product listed by our trusted sellers undergoes thorough repair, refurbishment, cleaning, and testing to ensure it’s in excellent working condition. On top of that, every purchase comes with free standard shipping, a 1-year warranty, and a 30-day return policy for added peace of mind. Whether you're shopping for Apple, Samsung, Dell, Microsoft, Nintendo, LG, or Google products, we’ve got deals you won’t want to miss.
</p>

   `,
    questionAr: 'أين يمكنني العثور على أفضل العروض على الإلكترونيات؟',
    answerAr: `
   <p class="c8">لقد أتيت إلى المكان الصحيح - مرحبًا بك في Popsy! كأحد الأسواق العالمية الرائدة للتقنيات المجددة، تُعد Popsy وجهتك المثالية للحصول على عروض مذهلة على الإلكترونيات. مع توفير يصل إلى %30-70 مقارنة بسعر الأجهزة الجديدة، يمكنك ترقية أجهزتك دون إنفاق الكثير.
</p>
<p class="c8">في Popsy، نحن ملتزمون بالجودة. يتم فحص كل منتج يعرضه البائعين الموثوقون لدينا بعناية، بما في ذلك الإصلاح، والتجديد، والتنظيف، والاختبار لضمان أنه في حالة عمل ممتازة. بالإضافة إلى ذلك، تأتي جميع المشتريات مع شحن قياسي مجاني، وضمان لمدة سنة واحدة، وسياسة إرجاع لمدة 30 يومًا لمنحك راحة البال. سواء كنت تبحث عن منتجات Apple أو Samsung أو Dell أو Microsoft أو Nintendo أو LG أو Google، لدينا عروض لا تُفوَّت.
</p>

    `,
  },
  {
    open: false,
    question: 'How Can I Get Popsy Deals?',
    answer: `
                <p class="c8">
     Finding great deals at Popsy is easy! We offer unbeatable discounts on a wide range of electronics, from smartphones and laptops to earbuds and gaming consoles—all year round. Our carefully curated sellers meet strict quality standards, so you can shop with confidence.

    </p>
    <p class="c8">
  Explore thousands of refurbished products, including iPhones, Samsung Galaxy devices, AirPods, Nintendo Switch consoles, Dell laptops, iPads, and even electric scooters. With discounts of Up to 70%, there’s something for everyone at Popsy.
</p>
  
                  `,
    questionAr: 'كيف يمكنني الحصول على عروض Popsy؟',
    answerAr: `
   <p class="c8">
   العثور على عروض رائعة في Popsy أمر سهل! نقدم خصومات لا تُضاهى على مجموعة واسعة من الإلكترونيات، من الهواتف الذكية وأجهزة الكمبيوتر المحمولة إلى سماعات الأذن وأجهزة الألعاب - طوال العام. يتم اختيار بائعينا بعناية لضمان تلبية معايير الجودة العالية، مما يمنحك تجربة تسوق بثقة.
</p>
<p class="c8">
   استكشف الآلاف من المنتجات المجددة، بما في ذلك أجهزة iPhone، وأجهزة Samsung Galaxy، سماعات AirPods، وأجهزة Nintendo Switch، وأجهزة كمبيوتر Dell المحمولة، وأجهزة iPad، وحتى السكوترات الكهربائية. مع خصومات تصل إلى %70، هناك شيء يناسب الجميع في Popsy.
</p>
`,
  },
  {
    open: false,
    question: 'How Do Popsy Discount Codes Work?',
    answer: `
               <p class="c8">
      Lucky enough to have a Popsy promo code? Great news—you’re about to save even more! Using your discount code is simple:

    </p>
    <ul class="c6 lst-kix_xyixmdi9rolb-0 start">
      <li class="c4 li-bullet-0">
        <span class="c3">1. Add your chosen item to your cart.</span>
      </li>
        <li class="c4 li-bullet-0">
        <span class="c3">2. At checkout, enter your code into the “promo code” field.
</span>
      </li>
        <li class="c4 li-bullet-0">
        <span class="c3">3. Watch the price drop instantly before you confirm your purchase!
</span>
      </li>
      
    </ul>           
`,
    questionAr: 'كيف تعمل كودات الخصم في Popsy؟',
    answerAr: `
       <p class="c8">
   محظوظ بالحصول على رمز ترويجي من Popsy؟ أخبار رائعة - على وشك أن توفر المزيد! استخدام رمز الخصم بسيط:
</p>
<ul class="c6 lst-kix_xyixmdi9rolb-0 start">
    <li class="c4 li-bullet-0">
        <span class="c3">1. أضف المنتج الذي اخترته إلى سلة التسوق.
</span>
    </li>
    <li class="c4 li-bullet-0">
        <span class="c3">2. عند الدفع، أدخل الرمز في حقل "رمز ترويجي".</span>
    </li>
    <li class="c4 li-bullet-0">
        <span class="c3">3. شاهد السعر ينخفض فورًا قبل تأكيد الشراء!
</span>
    </li>
</ul>
`,
  },
];
